import { useEffect, useState } from 'react';

let inflight = null;
const load = () => {
  if (!inflight) {
    inflight = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/diwali-offer`)
      .then((r) => r.json())
      .catch(() => ({ popup: false, badges: false }));
  }
  return inflight;
};

export function useDiwaliOffer() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    load().then((c) => alive && setCfg(c));
    return () => { alive = false; };
  }, []);
  return cfg;
}
